import { HostBackend } from '../../../Routes/HostBackend.js';
import { PostRefresh } from '../Functions/FetchHeaders.js';

export const MsgBackend = (props) => {
    const { entity, msg, setMsg } = props;
    const backend = HostBackend();
    const refresh = sessionStorage.getItem('refresh');

    const handleRefresh = async () => {
        const res = await fetch(`${backend}/auth/admin/refresh`, PostRefresh(refresh));
        const datas = await res.json();
        if (datas && datas.token) {
            sessionStorage.setItem('token', datas.token);
            window.location.href = `/admin/entity/collection/${entity}`;
        }
        if (datas && datas.err) {
            setMsg({ err: datas.err });
        }
    }
    if (msg.refresh) {
        return (
            <div className="msg-backend bkg-error">
                {`Message: ${msg.msg}`}
                <button className="button" onClick={handleRefresh}>REFRESH</button>
            </div>
        );
    }
    if (msg.msg) {
        return (
            <div className="msg-backend bkg-success">
                {`Message: ${msg.msg}`}
                <a className="button" href={msg.link} alt="link">GO</a>
            </div>
        );
    }
    if (msg.err) {
        return (
            <div className={`msg-backend bkg-error`}>
                {`Message: ${msg.err}. You must relogin...`}
                <a className="button" href={`/admin/login`} alt="link">LOGIN</a>
            </div>
        );
    }
    if (!msg) {
        return (<></>);
    }
} 